(function() {
    'use strict';

    angular.module('product')
        .controller('ProductOptionGroupListController', ProductOptionGroupListController);

    ProductOptionGroupListController.$inject = ['$state', 'notificationSrvc', 'productOptionGroupDataSrvc', 'productOptionGroupSrvc', 'productOptionGroupMessagesConst', 'lodashService', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'productOptionGroupPermissionsConst', 'filterQuerySrvc', 'downloadLinkSrvc', 'errorNotificationSrvc'];

    function ProductOptionGroupListController($state, notificationSrvc, productOptionGroupDataSrvc, productOptionGroupSrvc, productOptionGroupMessagesConst, lodashService, datatableDefaultPageSizeValueConst, checkSearchSrvc, productOptionGroupPermissionsConst, filterQuerySrvc, downloadLinkSrvc, errorNotificationSrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.groupsRows = [];
        self.groupsCols = [{
            title: 'ID',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Opis',
            value: 'description',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Wybór',
            value: 'group_choice',
            type: 'text',
            searchable: true,
            orderable: true
        }];

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.modelPermissions = productOptionGroupPermissionsConst;
        self.searchQuery = {
            pk: null,
            name: null,
            description: null,
            group_choice: null,
            ordering: null
        };

        self.exportLoading = false;

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;
        self.onClick = onClick;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.optionsExport = optionsExport;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getGroups();
        }

        function getGroups(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    pk: self.searchQuery.pk,
                    name: self.searchQuery.name,
                    description: self.searchQuery.description,
                    group_choice: self.searchQuery.group_choice,
                    ordering: self.searchQuery.ordering
                };
            }
            return productOptionGroupDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.groupsRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getGroups);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.productOptionGroup.create');
        }

        function onClick(row) {
            $state.go('layout.productOptionGroup.detail', { pk: row.pk });
        }

        function onEdit(row) {
            $state.go('layout.productOptionGroup.update', { pk: row.pk });
        }

        function onDelete(row) {
            productOptionGroupSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", productOptionGroupMessagesConst.delete);
                lodashService.remove(self.groupsRows, { pk: row.pk });
            }, function(response) {
                notificationSrvc.notification("error", response.data.data.non_field_errors[0]);
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getGroups();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getGroups();
        }

        function optionsExport() {
            self.exportLoading = true;

            return productOptionGroupDataSrvc.optionsExport({
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    pk: self.searchQuery.pk,
                    name: self.searchQuery.name,
                    description: self.searchQuery.description,
                    group_choice: self.searchQuery.group_choice,
                    ordering: self.searchQuery.ordering
                })
                .$promise
                .then(
                    function(response) {
                        downloadLinkSrvc.saveFile(response);
                    },
                    function(response) {
                        errorNotificationSrvc.displayErrors(response.data);
                    }
                ).finally(
                    function(response) {
                        self.exportLoading = false;
                        return response;
                    }
                );
        }
    }
})();
